  // TopHoldings.js
  import React , { useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  //import DOMPurify from 'dompurify';
  //import './TopHoldings.css';


  const TopHoldings = ({
	  scBreakdownDataUrl,
	}) => {
	  const { t, i18n } = useTranslation();	
	  const [topholdingsData, setTopholdingsData] = useState(null); 
	  const [asOfDate, setAsOfDate] = useState(null); 
	
	  useEffect(() => {
		const fetchData = async () => {
		let baseUrl = process.env.REACT_APP_DATA_URL || '#{DATA_URL}';

		  const fundResponse = await fetch(`${baseUrl}${scBreakdownDataUrl}`);
	  
		  if (!fundResponse.ok) {
			throw new Error('HTTP error!');
		  }
	  
		  const fetchedFundDataArray = await fundResponse.json();
		  const fundDataObject = Array.isArray(fetchedFundDataArray) ? fetchedFundDataArray[0] : fetchedFundDataArray;

		  let topHoldings;
		  if (fundDataObject && Array.isArray(fundDataObject.TopHoldings)) {
			topHoldings = fundDataObject.TopHoldings;
		  }


		  setTopholdingsData(topHoldings);

		  setAsOfDate(fundDataObject?.BreakdownAsOfDate);

		//   setTimeout(() => {
		// 	window.applicationReInit(['TopHoldings']);
		//   }, 100);        
		};
	  
		fetchData().catch((error) => console.error(error));
  
	  }, [scBreakdownDataUrl, t, i18n]);
  
	  if (!topholdingsData) {
		return <div>Loading...</div>;
	  }

 
	  return (
		<div className="l-container">
			<div className="c-activeinvest-top-holding l-grid u-margin-top-2m u-margin-bottom-xl">
				<div className="l-grid__row justify-content-center">
					<div className="l-grid__column-large-8 l-grid__column-medium-12 l-grid__column-small-12 u-text-align-center">
						<h3 className="c-heading c-heading--subsection-large u-margin-bottom-sm">
							{t("FundData.TopHoldings.Headline", "Top Holdings")}
						</h3>
						<p className="c-copy u-margin-top-sm">
							{t("asOfDateLabel")} {asOfDate}
						</p>
						<table className="c-table c-table--agi has-border">
							{i18n.exists("FundData.TopHoldings.CompanyName") &&
								i18n.exists("FundData.TopHoldings.HoldingInPercent") && (
									<thead>
										<tr className="c-table__header__row" tabIndex="0">
											<th className="c-table__header__cell u-text-weight-extra-bold" tabIndex="0">
												<div className="c-table__header-wrapper">
													<span className="c-table__header__title" tabIndex="0">
														{t("FundData.TopHoldings.CompanyName")}
													</span>
												</div>
											</th>
											<th className="c-table__header__cell u-text-weight-extra-bold" tabIndex="0">
												<div className="c-table__header-wrapper">
													<span className="c-table__header__title" tabIndex="0">
														{t("FundData.TopHoldings.HoldingInPercent")}
													</span>
												</div>
											</th>
										</tr>
									</thead>
								)}
							<tbody className="c-table__content">
								{topholdingsData.map((topHolding, index) => (
									<tr className="c-table__row" tabIndex="0" key={index}>
										<td className="c-table__cell u-text-weight-semibold">
											<div className="c-table__cell-wrapper" tabIndex="0">
												<span className="c-table__text">
													{topHolding.label}
												</span>
											</div>
										</td>
										<td className="c-table__cell">
											<div className="c-table__cell-wrapper" tabIndex="0">
												<span className="c-table__text">
													{topHolding.value && (
														<span>
															{topHolding.value} %
														</span>

													)}
												</span>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
    );
  }
  
  export default TopHoldings;